export const Emblem = () => {
    return (
        <div className="d-flex justify-content-center align-items-center position-relative emblem-container pt-2">
            <img
                className="img-fluid rotating-image position-absolute outer-image"
                src="/images/diffrentia/quadouter.png"
                alt=""
                style={{ zIndex: 1 }}
            />
            <img
                className="img-fluid inner-image"
                src="/images/diffrentia/quadinner.png"
                alt=""
            />
            <h1 className="cinzel-decorative-header" style={{ zIndex: 2 }}>
                Diffrentia
            </h1>
        </div>
    );
};
